import { cn } from '@jk-core/utils';
import ArrowIcon from '@/assets/arrow.svg';
import DropIcon from '@/assets/drop-arrow.svg';
import { CalendarView } from '@/Calendar/type';
import styles from './DateLabel.module.scss';

interface DateLabelProps {
  viewDate: Date;
  onArrowClick: (direction: 'prev' | 'next') => void;
  disabled: (direction: 'prev' | 'next') => boolean;
  method: CalendarView;
  selectMode?: CalendarView;
  setSelectMode?: (mode: CalendarView) => void;
  hideArrow?: 'prev' | 'next' | 'all' | null;
  range?: boolean;
}

export default function DateLabel({
  viewDate, onArrowClick, disabled, method, selectMode = 'day', setSelectMode = () => { }, hideArrow = null, range = false,
}: DateLabelProps) {
  return (
    <div className={cn({
      [styles.nav]: true,
      [styles['nav--range']]: range,
      [styles['nav--left']]: hideArrow === 'all',
    })}
    >
      {hideArrow !== 'all' && (
        <button
          className={styles.nav__button}
          type="button"
          onClick={() => onArrowClick('prev')}
          disabled={disabled('prev') || hideArrow === 'prev'}
        >
          {hideArrow !== 'prev' && <ArrowIcon />}
        </button>
      )}
      {range ? (
        <div className={cn({
          [styles.nav__label]: true,
          [styles['nav__label--left']]: hideArrow === 'all',
        })}
        >
          {`${viewDate.getFullYear()}년 ${viewDate.getMonth() + 1}월`}
        </div>
      ) : (
        <div className={cn({
          [styles.nav__label]: true,
          [styles['nav__label--left']]: hideArrow === 'all',
        })}
        >
          {method === 'year' && '연도 선택'}
          {method !== 'year' && (
            <button
              className={cn({
                [styles['nav__label--date']]: true,
                [styles['nav__label--date-selected']]: selectMode === 'year',
              })}
              type="button"
              onClick={() => setSelectMode('year')}
            >
              {`${viewDate.getFullYear()}년`}<DropIcon />
            </button>
          )}
          {method === 'day' && (
            <button
              className={cn({
                [styles['nav__label--date']]: true,
                [styles['nav__label--date-selected']]: selectMode === 'month',
              })}
              type="button"
              onClick={() => setSelectMode('month')}
            >
              {`${viewDate.getMonth() + 1}월`}<DropIcon />
            </button>
          )}
        </div>
      )}
      {hideArrow !== 'all' && (
        <button
          className={styles.nav__button}
          type="button"
          onClick={() => onArrowClick('next')}
          disabled={disabled('next') || hideArrow === 'next'}
        >
          {hideArrow !== 'next' && <ArrowIcon style={{ transform: 'rotate(180deg)' }} />}
        </button>
      )}
    </div>
  );
}
